export default "__VITE_ASSET__fed6642c__"